import { CbTopBaseResources } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources";
import { CbTopBaseResourcesEn } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources.En";
import { SocialProof } from "@/src/cashback/LandingPage/Version/social-proof";
import { useViewportInfoContext } from "@/src/contexts";
import { languageSelector } from "@/src/contexts/UserAuthenticationContext";
import { ConsentScreenType } from "@/src/modals/useConsents";
import PanelSection from "@/src/shared/panel-section";
import { LoginRegistrationCore } from "@Components/login-registration-core/login-registration-core";
import { TelemetryBoundary } from "@Components/telemetry-hoc/telemetry-boundary";

import bgImg from "./../_assets/bg_hero_center.jpg";
import bgImgMobile from "./../_assets/bg_hero_right_mobile.jpg";

import * as css from "./../../CashbackTopSection.module.css";
import * as versionCss from "./lpVersionF.module.css";

export function LpTopComponentVersionF() {
    const ME_VERISON = "F";

    const resources = languageSelector(CbTopBaseResources, CbTopBaseResourcesEn);

    const { isMobile } = useViewportInfoContext();

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            className={versionCss.lpVersionF}
            initialInView
        >
            <div className={versionCss.gridWrapper}>
                <div className={css.cashbackTopSectionComponent}>
                    <div className={css.textContent}>
                        <h1 className={css.subject} dangerouslySetInnerHTML={{ __html: resources.title }} />

                        <SocialProof />
                    </div>
                </div>

                <TelemetryBoundary
                    className={versionCss.formContainer}
                    telemetryCustom={{
                        eventName: "common-registerModal",
                        actionType: "View",
                        param1: ME_VERISON,
                    }}
                >
                    <LoginRegistrationCore
                        loginConsentScreenType={ConsentScreenType.LoginProcess}
                        registerConsentScreenType={ConsentScreenType.RegistrationProcess}
                        customRegisterButtonTelemetry={{
                            eventName: "cshbck-topSectionRegister",
                            actionType: "Click",
                            param1: ME_VERISON,
                        }}
                    />
                </TelemetryBoundary>

                <img src={isMobile ? bgImgMobile : bgImg} className={versionCss.bgHero} />
            </div>
        </PanelSection>
    );
}
